import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { st, Form, FormMessage, FormControl, HintView } from "lib/index";
import { stateSelector, updateProduct, validate, save } from "../index";
import ProductVariantsListing from "../ProductVariantsListing";
import Hint from "./StepPricelistHint";
import ProductVariantPricelistFormSection from "./ProductVariantPricelistFormSection";

@connect(
  (state) => ({
    product: stateSelector(state).product,
    submitLoading: stateSelector(state).submitLoading,
    valid: stateSelector(state).valid,
    errors: stateSelector(state).errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateProduct,
        validate,
        save,
      },
      dispatch
    )
)
export default class StepPricelistForm extends React.PureComponent {
  handleSubmit(event) {
    const { save } = this.props;
    event.preventDefault();
    save();
  }

  handleProductPropChange(prop, value) {
    const { product, updateProduct } = this.props;
    updateProduct({
      ...product,
      [prop]: value,
    });
  }

  handleProductVariantChange(nextProductVariant) {
    const { product, updateProduct } = this.props;
    updateProduct({
      ...product,
      product_variants: product.product_variants.map((x) =>
        x.uuid === nextProductVariant.uuid ? nextProductVariant : x
      ),
    });
  }

  handleProductPriceCurrencyChange(nextCurrency) {
    const { product, updateProduct } = this.props;
    updateProduct({
      ...product,
      price_currency: nextCurrency,
      default_saas_commision_amount: product.default_saas_commision_amount && {
        ...product.default_saas_commision_amount,
        currency: nextCurrency,
      },
      product_variants: product.product_variants.map((pv) => ({
        ...pv,
        coupon_discount_amount: pv.coupon_discount_amount && { ...pv.coupon_discount_amount, currency: nextCurrency },
        coupon_offer_price_before_discount: pv.coupon_offer_price_before_discount && {
          ...pv.coupon_offer_price_before_discount,
          currency: nextCurrency,
        },
        product_pricelist_items: pv.product_pricelist_items.map((ppi) => ({
          ...ppi,
          price: { ...ppi.price, currency: nextCurrency },
        })),
      })),
    });
  }

  render() {
    const { readOnlyAccess, product, submitLoading, valid, errors, validate } = this.props;
    const onBlur = validate;

    return (
      <HintView.Container>
        <HintView.Content>
          <Form className="text" onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
            <h1>{I18n.t("papp.products.EditProductView.StepPricelist.form_title")}</h1>

            {!!errors.base && <FormMessage error={errors.base} />}

            <ProductVariantsListing
              product={product}
              isProductVariantValid={(pv) =>
                errors.hasValidProp(`product.product_variants[${pv.uuid}].pricelist_type`) &&
                errors.hasValidProp(`product.product_variants[${pv.uuid}].product_pricelist_items`)
              }
              renderProductVariant={(pv) => (
                <ProductVariantPricelistFormSection
                  readOnlyAccess={readOnlyAccess}
                  name={`product.product_variants[${pv.uuid}]`}
                  errors={errors}
                  product={product}
                  product_variant={pv}
                  product_price_currency={product.price_currency}
                  editedLocale={this.props.editedLocale}
                  onBlur={onBlur}
                  onChange={this.handleProductVariantChange.bind(this)}
                  onProductPriceCurrencyChange={this.handleProductPriceCurrencyChange.bind(this)}
                />
              )}
            />
            <button type="submit" disabled={submitLoading} hidden />
          </Form>
        </HintView.Content>
        <HintView.Sidebar>
          <Hint />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPricelist/StepPricelistForm.jsx